// Define constants events
export const EVENTS = {
    SHOPIFY_CLOSED_FAILURE: 'Closing Failed',
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_FAILURE: 'GET_DATA_FAILURE',
    UPDATE_DATA_SUCCESS: 'UPDATE_DATA_SUCCESS',
    UPDATE_DATA_FAILURE: 'UPDATE_DATA_FAILURE',
    GET_SHOPIFY_DASHBOARD_DATA_SUCCESS: 'GET_SHOPIFY_DASHBOARD_DATA_SUCCESS',
    GET_SHOPIFY_DASHBOARD_DATA_FAILURE: 'GET_SHOPIFY_DASHBOARD_DATA_FAILURE',
    VERIFY_CUSTOMIZATIONS_SUCCESS: 'VERIFY_CUSTOMIZATIONS_SUCCESS',
    FETCH_CUSTOMIZATIONS_SUCCESS: 'FETCH_CUSTOMIZATIONS_SUCCESS',
    FETCH_CUSTOMIZATIONS_ERROR: 'FETCH_CUSTOMIZATIONS_ERROR',
    SYNC_CUSTOMIZATIONS_SUCCESS: 'SYNC_CUSTOMIZATIONS_SUCCESS',
    SYNC_CUSTOMIZATIONS_ERROR: 'SYNC_CUSTOMIZATIONS_ERROR',
};
   
    
